<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import Sidebar from "sidebar";

export default {
  mixins: [fandomBasicMixin],
  components: {
    Sidebar
  },
  mounted: function () {
    this.content.stripes.forEach(stripe => {
      Vue.set(stripe, "width", 12); // force 12 columns
    });

    Vue.nextTick(() => {
      $('body').scrollspy({ target: "#sidebar-nav" });
    })
  },
  computed: {
    headerActivation() {
      return Fandom.exists(this.content.title);
    },
    getContentSidebar() {
      return this.pageModel.name_to_content[this.content.sidebar];
    }
  },
  methods: { }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" page-with-sidebar-component>
    <div class="position-relative header d-flex align-items-center bg-cover-center" v-if="headerActivation">
      <div class="container-fluid">
        <div class="row my-4 justify-content-center">
          <div class="col-md-10">
            <p class="category" v-if="content.category">{{content.category}}</p>
            <component :is="content.title_tag || 'h1'" class="display-2 my-4">{{content.title}}</component>
            <component :is="content.description_tag || 'div'" class="h2" v-html="content.description"></component>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <div class="row">
            <div class="col-12 col-lg-3 px-0">
              <sidebar :content="getContentSidebar" class="sticky-top-header mx-3 mx-md-0"></sidebar>
            </div>
            <div class="col-12 col-lg-9 px-0">
              <div v-for="stripe in content.stripes" :key="stripe.$id" class="pl-lg-5">
                <span v-if="stripe.stripe_id" class="anchor" :id="stripe.stripe_id"></span>
                <component :is="stripe.layout" :content="stripe" :opt-container-content="containerContent"></component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[page-with-sidebar-component] {

  .sticky-top-header {
    position: sticky;
    top: calc(#{$header-height-sm});
  }

  @include media-breakpoint-up(md) {

    .anchor {
      display: block;
      height: $header-height-sm;
      margin-top: -$header-height-sm;
      visibility: hidden;
    }
  } 

  .header {
    background-color: $gray-200;
  }
} 
</style>